import MuiTableFooter, { TableFooterProps as MuiTableFooterProps } from '@mui/material/TableFooter';

export type TableFooterProps = MuiTableFooterProps;

export const TableFooter = (props: TableFooterProps) => {
  return <MuiTableFooter {...props} />;
};
